export const state = () => {
    return {
        siteGroupsList: [],
        selectedSiteGroupsList: [],
        filteredSiteGroupsObjects: [],

        networkList: [],
        selectedNetworkList: [],
        filteredNetworkObjects: []
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/scrubRateHourlyReport/state.js